import { ListRange, SearchCriteriaBase } from '../../../../../common/models';
import { PartnerDetailsModel } from './partner-details.model';
import { PartnerExtIdsModel } from './partner-external-ids.model';
import { DEFAULT_PAGE_SIZE, ListQueryParam } from '../../../../../common/constants';
import { PartnerListFiltersModelBase, PartnerType } from '../constants/partner.constant';

export class PartnerBrief {
  id?: number;
  active: boolean;
  approved: boolean;
  name: string;
  type: PartnerType;
  country: string;
  city: string;
  streetName: string;
  streetNumber: string;
  region: string;
  zipCode: string;
  shortName: string;
  extIds: PartnerExtIdsModel[];
}

export class PartnerModel extends PartnerBrief {
  creatorId: number;

  constructor(params?: PartnerModel) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class PartnerRequestModel {
  constructor(partnerDetails: Partial<PartnerDetailsModel>, extIds: PartnerExtIdsModel[]) {
    if (partnerDetails && extIds) {
      Object.assign(this, partnerDetails, { extIds });
    }
  }
}

export class PartnerListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Active]: boolean;
  [ListQueryParam.PartnerTypeFilter]: string;
  [ListQueryParam.Name]: string;

  constructor(params?: Partial<PartnerListSearchCriteria> | ListRange | PartnerType) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}

export class PartnerSearchCriteria extends PartnerListFiltersModelBase {
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE;
  [ListQueryParam.Page] = 0;

  constructor(params?: PartnerSearchCriteria) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
